import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const links = [
  { label: "Work", href: "#services" },
  { label: "Reviews", href: "#reviews" },
  { label: "About", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled
          ? "bg-bone/80 backdrop-blur-xl border-b border-forest-ink/10 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <nav className="mx-auto max-w-[1400px] px-6 md:px-12 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center"
        >
          <img
            src="https://customer-assets-gfyr7b9c.emergentagent.net/job_berm-maintenance/artifacts/t4boxoco_IMG_0040.webp"
            alt="SideBerms Property Maintenance"
            className="h-11 md:h-14 w-auto object-contain mix-blend-multiply"
          />
        </button>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-sm text-forest-muted hover:text-forest-ink transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <span className="hidden sm:flex items-center gap-1 text-forest-ink text-sm">
            <Star size={14} className="fill-clay text-clay" /> 5.0
          </span>
          <button
            data-testid="nav-quote-btn"
            onClick={() => go("#quote")}
            className="group relative overflow-hidden rounded-full bg-forest text-bone px-5 py-2.5 text-sm tracking-wide"
          >
            <span className="relative z-10">Get a Quote</span>
            <span className="absolute inset-0 bg-forest-dark translate-y-full group-hover:translate-y-0 transition-transform duration-400 ease-out" />
          </button>
        </div>
      </nav>
    </motion.header>
  );
}
